import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Section from "../components/section"
import Carousel from "../components/carousel"
import cl from "../images/products/ML_CircleLoop@2x.png"
import sa from "../images/products/ML_SmartAgent@2x.png"
import spci from "../images/products/ML_SmartPci@2x.png"
import circleLoop from "../images/products/circleloop-logo-text.svg"
import smartAgent from "../images/products/smartagent-logo-text.svg"
import smartPci from "../images/products/smartpci-logo-text.svg"

import heroProducts from "../images/products/ML_hero-Products.jpg"

const carouselData = [
  {
    title: 'Meet our <span class="highlight">products.</span>',
    backgroundImage: heroProducts,
  },
]

const PaymentsPCI = () => {
  return (
    <Layout>
      <SEO
        title="Our Products - Modern, Scalable Customer Experience Communication Technology"
        description="We power the future of digital customer experience transformation through cutting-edge communication technology. Creators of CircleLoop, SmartAgent and SmartPCI."
        keywords="mission labs products, circleloop, smartagent, smartpci, agent desktop, agent desktop for amazon connect, omnichannel desktop, digital customer experience, ai, artificial intelligence, natural language processing, amazon connect, amazon lex, amazon polly, cloud communications, business phone system, pbx replacement, cloud based phone system, omnichannel cloud, uk technology companies, cloud communications, cloud phone provider, manchester tech, tech startup, mobile technology, app development, software companies, tech startup manchester, tech company lancashire, manchester digital, aws partner"
        robots="index, follow"
        revisit_after="1 month"
      />
      <div className="carousel-slick">
        <Carousel data={carouselData} />
      </div>

      <Section image={cl} noparagraph reverse>
        <h2>
          <img alt="circleloop" src={circleLoop} className="heading-logo" />
        </h2>
        <hr />
        <p className="lead">
          CircleLoop is our cloud-based business phone system that works
          anywhere in powerful desktop and mobile apps. Delivered in a modern
          day self-service SaaS model with powerful features and multiple
          integrations CircleLoop replaces traditional phone systems,
          transforming user mobility and helping businesses to get more done.
        </p>
        <Link
          className="mobile-hidden button"
          target="_blank"
          to="https://www.circleloop.com/"
        >
          Visit Site
        </Link>
      </Section>

      <Section theme="theme-blue" image={sa} noparagraph>
        <h2>
          <img alt="smartagent" src={smartAgent} className="heading-logo" />
        </h2>
        <hr />
        <p className="lead">
          SmartAgent is our streamlined omnichannel Contact Centre agent
          application which integrates with Amazon Connect. It provides agents
          with all the data, information and reporting they need to provide
          better customer experience, whilst reducing handling times and costs.
          SmartAgent integrates with your back end systems to provide a single
          pane of glass for all contact.
        </p>
        <Link
          className="mobile-hidden button"
          target="_blank"
          to="http://www.smartagent.io/"
        >
          Visit Site
        </Link>
      </Section>

      <Section theme="theme-green" image={spci} noparagraph reverse>
        <h2>
          <img alt="smartPXI" src={smartPci} className="heading-logo" />
        </h2>
        <hr />
        <p className="lead">
          SmartPCI is our PCI-compliant digital payments solution for enterprise
          contact centre operators. SmartPCI integrates with Amazon Connect,
          SmartAgent and your PSP creating a completely secure and PCI-compliant
          environment for IVR, digital, and agent-initiated payments. SmartPCI
          removes your physical contact centre environment from PCI DSS scope,
          reducing annual audit requirements.
        </p>
        <Link
          className="mobile-hidden button"
          target="_blank"
          to="/solutions/payments-pci"
        >
          Find out more
        </Link>
      </Section>
    </Layout>
  )
}

export default PaymentsPCI
